{
	"type": "line",
	"minzoom": 8,
	"filter": ["has", "dorasclass"],
	"layout": {},
	"paint": {
		"line-color": [
			"match",
			["downcase", ["get", "dorasclass"]],
			"motorway",
			"#1f2650",
			"principal arterial",
			"#1b294f",
			"transit only corridor",
			"#292954",
			"rural highway",
			"#102f4d",
			"secondary arterial",
			"#252d53",
			"rural link",
			"#08374b",
			"enterprise street",
			"#114946",
			"connector street",
			"#0e5147",
			"urban centre street",
			"#4c644d",
			"neighbourhood street",
			"#105e3f",
			"yield street",
			"#0d6a3e",
			"residential way",
			"#0b723e",
			"residential lane",
			"#0b733d",
			"transit arterial",
			"#a04380",
			"arterial high street",
			"#a04380",
			"connector avenue",
			"#8e3f78",
			"transit street",
			"#a04380",
			"destination high street",
			"#a3467e",
			"transit mall",
			"#d1962b",
			"civic high street",
			"#d1962b",
			"service lane",
			"#c3962f",
			"civic lane",
			"#d1962b",
			"#ddd"
		],
		"line-width": 5
	}
}
